var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('location-form',{ref:"locationForm",attrs:{"address":_vm.address,"scroll-id":_vm.scrollId},on:{"next":_vm.next,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }